import { ReactNode, useEffect, useRef, useState } from 'react'

import cn from 'clsx'

import s from './styles.module.scss'

export const TickerPrice = ({
  price,
  children,
  classNames,
}: {
  price: number
  children?: ReactNode
  classNames?: string
}) => {
  const [priceValue, setPriceValue] = useState(price)
  const [className, setClassName] = useState(s.container)
  const timeout = useRef<null | NodeJS.Timeout>(null)
  useEffect(() => {
    if (price === priceValue) {
      return
    }
    setClassName(cn(s.container, price > priceValue ? s.rise : s.fall))
    if (timeout.current) {
      clearTimeout(timeout.current)
      timeout.current = null
    }
    timeout.current = setTimeout(() => {
      setClassName(s.container)
    }, 2000)
    setPriceValue(price)
    return () => {
      if (timeout.current) clearTimeout(timeout.current)
    }
  }, [price])
  return <div className={cn(className, classNames)}>{children}</div>
}
